import { useLayoutEffect } from "react";

// Auto-resize a textarea to fit content up to `maxLines`, then scroll internally.
export function useAutoGrow(ref, value, maxLines = 4) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const cs = window.getComputedStyle(el);
    const line = parseFloat(cs.lineHeight) || 20;
    const padTop = parseFloat(cs.paddingTop) || 0;
    const padBottom = parseFloat(cs.paddingBottom) || 0;
    const border = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
    const max = line * maxLines + padTop + padBottom + border;
    const h = Math.min(el.scrollHeight, max);
    el.style.height = h + "px";
    el.style.overflowY = el.scrollHeight > max ? "auto" : "hidden";
  }, [ref, value, maxLines]);
}
